<template>
    <MapBasic :circles="circles" :loading-data="loading" :markers="markerList" :polygons="polygons"
              :refreshCenterCount="refreshCenterCount" :disable-back-navigation="filterOpen" show-search/>
</template>

<script>
import MapBasic from "@/components/MapBasic/MapBasic";

export default {
  name: "ZoneMap",
  components: {MapBasic},
  props: {
    zoneIds: {
      type: Array,
      required: true,
    },
    filterOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      zones: [],
      markers: [],
      loading: false,
      refreshCenterCount: 0,
    };
  },
  mounted() {
    if (this.organizationId) {
      this.getZones();
    }
  },
  computed: {
    markerList() {
      return this.markers;
    },
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    filterZones() {
      return this.zones.filter(zone => this.zoneIds.includes(zone.ZoneID));
    },
    circles() {
      return this.filterZones.filter(zone => zone.Shape === 'Circle').map(zone => ({
        lat: zone.Points[0].Latitude,
        lng: zone.Points[0].Longitude,
        radius: zone.Radius,
        type: zone.Type,
        id: zone.ZoneID,
        title: zone.Name,
      }));
    },
    polygons() {
      return this.filterZones.filter(zone => zone.Shape === 'Polygon').map(zone => ({
        points: zone.Points.map(point => ({
          lat: point.Latitude,
          lng: point.Longitude,
        })),
        type: zone.Type,
        id: zone.ZoneID,
        title: zone.Name,
      }));
    },
  },
  watch: {
    organizationId() {
      this.getLocations();
    },
    zoneIds() {
      if (this.zoneIds.length === 1) {
        this.setMarkers();
      } else {
        this.markers = [];
        this.refreshCenterCount++;
      }
    }
  },
  methods: {
    getZones() {
      this.loading = true;
      const url = this.$store.getters.zones;
      this.axios.get(url).then(({data}) => {
        this.zones = data.Result;
        if (this.zoneIds.length === 1) {
          this.setMarkers();
        } else {
          this.markers = [];
          this.refreshCenterCount++;
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
    },
    setMarkers() {
      const url = this.$store.getters.zoneLocations(this.zoneIds[0]);
      this.axios.get(url).then(({data}) => {
        this.markers = data.Result.map(marker => ({
          ...marker,
          lat: marker.Position.Latitude,
          lng: marker.Position.Longitude,
        }));
      });

    }
  }
};
</script>

<style scoped>

</style>